import React, { useState, useContext, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import _ from 'lodash';
import { SurveyContext } from '../../SurveyContext';

const getAllQuestions = (surveyData) => {
    const allQuestions = [];
    surveyData.forEach(survey => {
        survey.fields.forEach(field => {
            if (allQuestions.indexOf(field) === -1) {
                allQuestions.push(field);
            }
        });
    });
    return allQuestions;
}
const CampaignSurveys = (props) => {
    const { customers } = useContext(SurveyContext);

    const [name, setName] = useState('');
    const [activeSurveys, setActiveSurveys] = useState([]);
    const [surveyData, setSurveyData] = useState([]);
    const [loading, setLoading] = useState(false);

    const clientId = props.match.params.clientId;
    const campaignId = props.match.params.campaignId;
    const allQuestions = getAllQuestions(surveyData);

    useEffect(() => {
        (async function getCustomerData() {
            setLoading(true);
            const customer = customers.find(customer => customer.id === parseInt(clientId));
            if (!customer) {
                setLoading(false);
                return;
            };
            const customerSurveys = customer.campaigns.find(campaign => campaign.id === parseInt(campaignId))?.surveys || [];
            await getTypeformData(customerSurveys);
            setName(customer.name);
            setActiveSurveys(customerSurveys)
            setLoading(false);
        })()
      }, [campaignId, clientId, customers]);

    const getTypeformData = async (surveys) => {
        const dataRequests = [];
        surveys.forEach(survey => {
            dataRequests.push(fetch(`/.netlify/functions/typeform?type=getSingle&uid=${survey}`).then(response =>
                response.json()
            ).catch(err => console.log(`Error getting data for ${survey}: ${err}`)));
        });
        let outputs = await Promise.all(dataRequests).catch(err => {
            outputs = null;
        });
        const surveyData = [];
        if (outputs) {
            outputs.forEach((output, idx) => {
                if (output && output.status >= 200 && output.status < 300) {
                    const data = output.message;
                    let surveyObject = {
                        fields: [],
                        title: data.title,
                        id: data.id,
                        type: surveys[idx].type,
                        language: data.settings ? data.settings.language : ''
                    };
                    surveyObject.fields = data.fields?.map(field => field.ref) || [];
                    surveyData.push(surveyObject);
                }
            })
            setSurveyData(surveyData);
        }
    }

    const goToAllCampaigns = () => {
        props.history.push(`/campaigns/${clientId}`);
    }

    const goToSurvey = (id) => {
        props.history.push(`/surveys/${id}`);
    }

    if(_.isEmpty(activeSurveys)) return null;
    return (
        <div style={{ width: '100%', height: '100%' }}>
            <div style={{ display: 'flex', position: 'relative' }}>
                <Button onClick={goToAllCampaigns} variant="outlined" color="secondary" style={{ height: 40, marginTop: 8 }}> All Campaigns </Button>
                <h3 style={{ marginLeft: 20, marginRight: 70 }}> {name} </h3>
                <h3> {`${activeSurveys.length} active surveys`}</h3>
            </div>
            <div style={{ display: 'flex', height: '100%', alignItems: 'center' }}>
                <div style={{ width: 250, height: 500, border: '1px solid black', padding: 5, marginRight: 40 }}>
                    <div style={{ height: 20 }}>
                        <h4 style={{ margin: 3, marginLeft: 10 }}> Currently Live </h4>
                    </div>
                    <div style={{ overflowY: 'scroll', height: 480 }}>
                        <ul style={{ paddingLeft: 25, fontSize: 14 }}>
                            {allQuestions.map(field => (
                                <li key={field}>
                                    {field}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
                <div style={{ display: 'flex', height: '100%', alignItems: 'center', overflowX: 'scroll' }}>
                    {surveyData.map((survey) => (
                        <div key={survey.id} style={{ width: 250, height: 500, border: '1px solid black', marginRight: 1, padding: 5, position: 'relative' }}>
                            <div style={{ borderBottom: '1px solid black', height: 110 }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ display: 'flex', flexDirection: 'column', marginRight: 10 }}>
                                        <h4 style={{ margin: 3 }}> {survey.id} </h4>
                                        <p style={{ margin: 3 }}> {`Language: ${survey.language}`} </p>
                                    </div>
                                </div>
                                <p style={{ marginLeft: 10, fontSize: 14, marginTop: 3 }}> {survey.title} </p>
                            </div>
                            <div style={{ overflowY: 'scroll', height: 360 }}>
                                <ul style={{ paddingLeft: 25, fontSize: 14 }}>
                                    {survey.fields.map(field => (
                                        <li key={field}>
                                            {field}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div style={{ height: 40, width: '100%' }}>
                                <Button color="primary" onClick={() => goToSurvey(survey.id)} style={{ width: 250, textTransform: 'none' }}>
                                    See Survey
                            </Button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <Backdrop open={loading} style={{ zIndex: 5, color: '#fff' }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    )
}

export default CampaignSurveys;
